import { Facebook, Instagram, Linkedin, Twitter } from "react-feather";
import { Link, NavLink } from "react-router-dom";
import {
  WebpFooterbackground,
  WebpHomesectionbackground,
  WebpPwra,
  WebpCc,
  WebpPressureGuys,
  PngLogo,
  PngFooterback,
  PngPressure,
  PngKnightimg1,
  PngKnightimg2,
  JpegAfter1,
  JpegBrefore1,
  JpegAfter2,
  JpegBefore2,
} from "../assets";

// import https://thepressureguys.com/wp-content/uploads/2023/10/The-Pressure-Guys-Wall-and-Fence-Cleaning.webp

import { addAnimation } from "../utils/addAnimation";
import Contactus from "../components/Contactus";

export default function Index() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <>
      <section className="Homesection">
        <div className="Homesection__background">
          <img
            loading="eager"
            className="Homesection__background__img"
            src={WebpHomesectionbackground}
            alt="IMG"
          />
        </div>
        <div className="Homesection__content">
          <div className="Homesection__content__overlay">
            <div className="Homesection__content__overlay__content">
              <div className="Homesection__content__overlay__heading heading__font__styles">
                Quality Equipment, Quality
                <span> Results</span>
              </div>
              <div className="button__Content">
                <img src={WebpCc} alt="img" />
                <button
                  title="Get A Free Quote Today"
                  onClick={() => {
                    scrollToTop();
                    window.location.href = "/contactus";
                  }}
                  className="Homesection__content__overlay__button"
                >
                  Get A Free Quote Today
                </button>
                <img
                  className="Homesection__content__overlay__button__img"
                  src={WebpPwra}
                  alt="img"
                />{" "}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="PRESSURE">
        <div className="PRESSURE__content">
          <div className="PRESSURE__content__left">
            <div className="PRESSURE__heading">
              WELCOME TO KNIGHTS HOME SERVICE – PROFESSIONAL POWER WASHING
              ORLANDO; PRESSURE WASHING ORLANDO, FL AREA
            </div>
            <div className="PRESSURE__subheading">
              Are you interested in the best pressure washing Orlando FL
              services?
            </div>
            <div className="PRESSURE__subheading__two">
              You’re in the right place!
            </div>
            <div className="PRESSURE__heading__info">
              We service the greater Orlando area for residential work and the
              whole state of Florida for commercial work!
            </div>

            <div className="PRESSURE__heading__info">
              At Knights Home Service, we offer a full complement of pressure
              washing services – and we’re always ready to serve customers all
              over Florida! Interested in learning more about what we do? Here’s
              a list of our services!
            </div>
          </div>
          <div className="PRESSURE__content__right">
            <div className="PRESSURE__img">
              <img src={PngPressure} alt="img" />
            </div>
          </div>
        </div>
      </section>

      {/* <section className="aboutus__global__presence">
        <div className="aboutus__global__presence__content">
          <div className="aboutus__global__presence__content__left">
            <img src={WebpAboutusGlobalPresences} alt="  img" />
          </div>
          <div className="aboutus__global__presence__content__right">
            <div className="Facilitiesartsection__content__overlay__heading">
              {addAnimation(
                "The Best Home Appliances Repair Company in SHARJAH "
              )}
            </div>
            <div className="Facilitiesartsection__content__overlay__info">
              {addAnimation(
                "Our company offers professional home depot appliance repair service and top-notch cleaning services. Our goal is to provide our customers with excellent service and satisfaction, which is why we offer affordable prices and flexible scheduling options. Whether you need appliance repair or cleaning services, you can count on us to get the job done right."
              )}
            </div>
          </div>
        </div>
      </section> */}
      <section className="custom__flavor__main__container">
        <div className="custom__flavor__main__container__waraper">
          <div className="custom__flavor__card__wraper__img">
            <img
              loading="lazy"
              className="custom__flavor__card__img"
              src={PngKnightimg2}
              alt=" "
            />
          </div>

          <div className="custom__flavor__card__wraper__contant">
            <div className="custom__flavor__card__wraper__contant__heading">
              {addAnimation("House Washing")}
            </div>
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "House and building washing in Florida isn’t just a matter of maintaining your home and increasing its curb appeal. The humid, damp climate of Florida can turn your home’s exterior into a breeding ground for mold, fungi, algae, and more. If these organisms are left alone, they can damage your paint and siding, leaving permanent stains and unsightly patches.",
              )}
            </div>
            <br />
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "That’s why we’re proud to offer the best house-washing services in all of Florida. Whether your home’s exterior is built from vinyl, aluminum siding, stucco, brick, or any other material, we’ve got the expertise to clean away dirt, grime, and other debris – and leave your home looking brand-new!",
              )}
            </div>
            <br />

            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "Using safe, low-pressure equipment and advanced detergents, our professional power washing Orlando FL technicians will blast away dirt and grime. Contact us now to learn more about what we can do for your home!",
              )}
            </div>
          </div>
        </div>
        <div className="custom__flavor__main__container__waraper">
          <div className="custom__flavor__card__wraper__img">
            <img
              loading="lazy"
              className="custom__flavor__card__img"
              src={PngKnightimg1}
              alt=" "
            />
          </div>

          <div className="custom__flavor__card__wraper__contant">
            <div className="custom__flavor__card__wraper__contant__heading">
              {addAnimation("Roof Cleaning ")}
            </div>
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "Your roof has taken a lot of abuse over the years. This can result in the buildup of debris like leaves and sticks, as well as algae, dirt, and even mold. This buildup can result in damage to your roof gutter tiles or shingles, and even require you to replace entire sections of your roof, which can cost thousands of dollars.",
              )}
            </div>
            <br />
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "If you’re interested in preserving your roof and fighting back against the buildup of algae and mold, roof gutter cleaning from Knights Home Service is the right choice!",
              )}
            </div>
            <br />

            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "Using a specialized low-pressure washing system, we can apply advanced detergents and algaecide to your roof and gutters.",
              )}
            </div>
            <br />
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "Whether you’ve got asphalt shingles, a tile roof, or even a metal roof, we’re happy to keep your roof clean – and keep you safe and dry!",
              )}
            </div>
            <br />
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "Not only are those black streaks and mold on your roof annoying, but they are also actually harmful! In fact, insurance companies have threatened homeowners in the past with the cancellation of their insurance if they do not clean their roof. The reason is simple: mold is a living organism, and like all living organisms, it has to eat!",
              )}
            </div>
            <br />
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "That’s right, your roof is being slowly ingested by these microorganisms! In order to save you thousands of dollars on roof repair/replacement costs, we recommend a thorough cleaning of your roof every few years (or when you start to notice these black streaks). This practice will prolong the useful life of your roof. We use safe low-pressure cleaning techniques with chemicals to kill the mold spores at the root, which prolongs the time in between cleanings to give you the most value for your money.",
              )}
            </div>
          </div>
        </div>
        <div className="custom__flavor__main__container__waraper">
          <div className="custom__flavor__card__wraper__img">
            <img
              loading="lazy"
              className="custom__flavor__card__img"
              src={PngKnightimg2}
              alt=" "
            />
          </div>

          <div className="custom__flavor__card__wraper__contant">
            <div className="custom__flavor__card__wraper__contant__heading">
              {addAnimation("Surface Cleaning")}
            </div>
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "If it needs to be pressure washed, we can pressure wash it! We specialize in safe and effective surface cleaning of patios, decks, fences, porches, walkways, driveways, commercial loading docks, and many more surfaces!",
              )}
              Whether you have a pool deck that needs to be refreshed, a
              concrete driveway that has seen better days, or a walkway to your
              business that needs to be cleaned, we can do it all.
              <br />
              With advanced training, equipment, and the latest detergents,
              we’re the best choice for surface cleaning in Florida!
              <br />
              From low-pressure house washing to high-pressure concrete
              cleaning, we can do it all in Orlando, FL! Get in touch to learn
              more about our services and rates.
              <br />
              This is the most common item that we pressure wash. You’d be
              surprised how much the color of your driveway has faded. Let us
              bring it back to looking new! We use a commercial surface cleaner
              to lift and dispel dirt, grime, and microorganisms. Subsequently,
              we post-treat your driveway with diluted bleach to keep your
              driveway clean much longer.
            </div>
          </div>
        </div>
        <div className="custom__flavor__main__container__waraper">
          <div className="custom__flavor__card__wraper__img">
            <img
              loading="lazy"
              className="custom__flavor__card__img"
              src={PngKnightimg1}
              alt=" "
            />
          </div>

          <div className="custom__flavor__card__wraper__contant">
            <div className="custom__flavor__card__wraper__contant__heading">
              {addAnimation("Building Washing and Screen Enclosure Cleaning")}
            </div>
            <div className="custom__flavor__card__wraper__contant__text">
              {addAnimation(
                "Knights Home Service professional window cleaning and screen cleaning offers a lot of advantages:",
              )}
              <br />
              Extending the life of your paintings or screens
              <br />
              Eliminating bug nests
              <br />
              Eradicating any mold present on the surfaces
              <br />
              Increasing your curb appeal
              <br />
              The list of the benefits that a homeowner or an office owner
              enjoys cannot be exhausted. To enjoy many more of the benefits of
              cleaning windows, call on The Pressure Washing Orlando FL to help
              with all your window cleaning needs. Our window cleaning experts
              are the best in Orlando and the surrounding areas. And our window
              house cleaning services are top-notch with top-rated customer
              service. Here, Knights Home Service will serve you better than any
              other professional window cleaners in the area.
              <br />
              We can make your home or business look inviting to you, your
              family, or your customers. We will save you loads of time. Most of
              all, you do not have to worry about putting your family or
              employees on hold. Call Knights Home Service today and speak with
              one of our experts. We can help you determine the best schedule to
              suit your needs.
              <br />
            </div>
          </div>
        </div>
      </section>
      <section className="PRESSURE">
        <div className="PRESSURE__content">
          <div className="PRESSURE__content__left">
            <div className="PRESSURE__heading">Pressure Washing Experts</div>
            <div className="PRESSURE__subheading">
              If you are looking for pressure washing services in Orlando and
              surrounding areas, then you should know what is out there. It can
              be a great investment, and many homes or business owners don’t
              know what kind of services are available. As you read the list
              below, you might be pleasantly surprised by what you read. There
              are various areas of your property that can be cleaned up, saving
              you time, money, and property value:
            </div>
            <div className="PRESSURE__subheading__two">
              Roof Cleaning & Pressure Washing – Orlando and surrounding areas
            </div>
            <div className="PRESSURE__heading__info">
              There are some areas of your home that you don’t see all the time,
              but that doesn’t mean they’re not important. You need a power
              washing company to clean your roof. There is bacteria and other
              debris that can cause problems. We have a special way of cleaning
              your roof to avoid damaging it while protecting it going forward.
            </div>
            <div className="PRESSURE__subheading__two">
              Total Home Power Washing – Orlando and surrounding areas
            </div>
            <div className="PRESSURE__heading__info">
              Your entire home matters when it comes to your personal pride.
              However, there is also potential resale value that you are leaving
              on the table if you don’t get a full range of services. Don’t just
              leave it at the roof cleaning. We can give you a total clean,
              starting from the top all the way to the foundation. This way,
              your entire property is looking shining new again!
            </div>
            <div className="PRESSURE__subheading__two">
              Commercial Power Washing Services
            </div>
            <div className="PRESSURE__heading__info">
              We don’t just do homes. We can clean condos, government buildings,
              businesses, schools, and more. We are a well-rounded and versatile
              Orlando pressure washing company that you can have on call for a
              variety of needs you have. Pressure washing can improve curb
              appeal and send the right message about your business.
            </div>
            <div className="PRESSURE__subheading__two">
              Concrete Pressure Washing Orlando and surrounding areas
            </div>
            <div className="PRESSURE__heading__info">
              Oil, grime, moss, and more can grow on concrete. It’s a good idea
              to hire a pressure-washing company for your stone or brick. These
              materials gather a lot of dirt and grime over the years. It can
              build up, causing damage to your property faster than you think.
              It’s typically not a good idea to do it yourself. Especially with
              softer stones, because there is a difference between concrete and
              softer stones.
              <br />
              <br />
              Maybe you found our site by typing in ‘pressure washing services
              near me,’ or perhaps you heard about us from word of mouth. Either
              way, we hope this has been useful in educating you on the types of
              power washing you can have done. It’s not just about driveways or
              walkways, although this is one of the more common usages. So take
              an inventory of your property and ask yourself if there is
              something you could use. Then, feel free to reach out for your
              free estimate!
            </div>
          </div>
          <div className="PRESSURE__content__right">
            <div className="PRESSURE__img">
              <img src={PngPressure} alt="img" />
            </div>
          </div>
        </div>
      </section>
      <Contactus />
      <section className="County">
        <div className="County__content">
          <div className="County__content__left">
            <div className="County__content__left__heading">
              How to Clean Windows in Orange County
            </div>
            <div className="County__content__left__info">
              We all know how alluring the shine of a spotless glass window can
              be, whether in a residential or commercial setting, and no one
              would want to miss out. The beauty of the sunlight streaming in
              through a clean window is an everyday luxury that can’t be
              understated. Looking out the window or enjoying the gentle passage
              of Orange County air through your window, either if you are home
              or at your workplace, it’s surely not something you want to
              obstruct. So, the question becomes: how do you ensure the best
              window maintenance for that crisp, clear view? Enter The Pressure
              Guys, a reliable window cleaning company that has the answers to
              your questions. This essay gives you a guide on how to clean both
              the interior and the exterior of your windows, with a focus on the
              dedicated work of our skilled employees.
            </div>
            <div className="County__content__left__info">
              One major factor that you must first consider is the day’s choice.
              If the day is too sunny, it will affect the cleaning process as
              the water and detergent mix may evaporate too rapidly. That’s
              where our window washing Orange County service shines – you can
              trust Knights Home Service to select a perfect day for the
              cleaning. Instead of going through the tough exercise of cleaning
              or wondering which day would be perfect, make one choice that
              takes care of everything else—hire Knights Home Service. Their
              team of highly trained professionals uses state-of-the-art
              equipment, like their squeegee, and eco-friendly cleaning
              solutions to ensure that every window is sparkling clean, leaving
              your home or business looking its best.
            </div>
            <div className="County__content__left__info">
              Also, our employees are experts in window washing Orange County,
              which might be a valuable addition to our window cleaning service.
              With their expertise, solid work ethic, and attention to detail,
              you can trust Knights Home Service to meet your needs, seen
              through the positive reviews shared by satisfied customers.
              Whether you need regular maintenance or one-time window washers
              Orange County, Knights Home Service have got you covered.
            </div>
          </div>
          <div className="County__content__right">
            <div className="County__content__right__img">
              <img src={JpegBrefore1} alt="img" />
            </div>
          </div>
        </div>
        <div className="County__content">
          <div className="County__content__left">
            <div className="County__content__left__info__content">
              <div className="County__content__left__info__content__heading">
                Choose a Cool, Cloudy Day
              </div>
              <div className="County__content__left__info__content__info">
                There's no denying that the implements used for cleaning make a
                big difference. Brushes, sponges, and squeegees are staples.
                But, to get that sparkling clean, having a mix of water and
                detergent is also essential. Knights Home Service, the best
                window cleaner Orange County company, offer pressure washing
                services as well as regular window cleaning. Here, we ensure
                your window frames, screens, and glass surfaces are spotless.
                <br />
                <br />
                Our team of skilled window cleaning Orange County professionals
                uses eco-friendly cleaning solutions and techniques that include
                power washing to provide a thorough and streak-free cleaning
                experience. With our attention to detail, commitment to customer
                service, and extensive effort to maintain client satisfaction,
                you can trust Knights Home Service for all your Orange County
                window cleaning needs.
              </div>
              <div className="County__content__left__info__content__heading">
                Get the Cleaning Materials Ready
              </div>
              <div className="County__content__left__info__content__info">
                When cleaning, it's essential to stem the tide of spills. Laying
                a large towel down is a critical part of window cleaning,
                helping to prevent dirt and dust. This strategy, like using a
                ladder to reach higher windows, can be overlooked when trying to
                tackle it yourself or when you hire a less experienced service.
                The potential consequences include accidents and an
                unnecessarily lengthened cleaning process that results in
                fatigue.
                <br />
                <br />
                Knights Home Service, with their customer-focused mindset, never
                forget to do the needful. Their team of expert window cleaners
                uses state-of-the-art equipment and techniques, such as pressure
                washing, to ensure that every window in Orange County is left
                sparkling clean, removing all dirt, grime, and streaks with the
                utmost precision. Their efficient and thorough approach
                guarantees that you receive reliable and quality customer
                service, results appreciated by their customers as seen in their
                positive reviews. Whether you're in need of Orange County window
                cleaning services or professional Orange County window washing,
                Knights Home Service are the team to trust for superior results.
              </div>
              <div className="County__content__left__info__content__heading">
                Catch Spills with a Laid Towel
              </div>
              <div className="County__content__left__info__content__info">
                In addition to laying a large towel to catch spills, there are
                other pre-cleaning exercises to carry out. These preparatory
                tasks make the cleaning fast and effective, living up to Knights
                Home Service' well-known culture of efficiency, upheld at every
                single job site across Orange County. Their reliable employees
                set the standard for other window cleaning companies, thanks to
                their detailed work and exceptional customer service. With a
                team of experienced professionals and state-of-the-art
                equipment, Orange County Window Cleaning guarantees sparkling
                clean windows, leaving every customer satisfied and their homes
                or businesses looking their best. Whether it's a residential
                property or a commercial building, their meticulous attention to
                detail and commitment to serving their clients is what sets them
                apart.
              </div>
              <div className="County__content__left__info__content__heading">
                Fulfill all Pre-Cleaning Needs
              </div>
              <div className="County__content__left__info__content__info">
                The process of cleaning gives attention to details, like
                cleaning from the interior to the exterior. More than this is
                how the cleaning solution, expertly applied by a seasoned window
                cleaner, is squeezed off the windows, leaving them crystal clear
                and streak-free. Professional window cleaners in Orange County
                are experts in using the right tools and techniques, including
                power washing, to ensure a thorough and efficient cleaning
                process. If one end is done horizontally, the other is better
                done vertically. This method aids in identifying streaks,
                ensuring no spot is overlooked. The professional and creative
                approach is what sets Knights Home Service apart in Orange
                County.
              </div>
              <div className="County__content__left__info__content__heading">
                Clean Inside-Out
              </div>
              <div className="County__content__left__info__content__info">
                When cleaning, attention must be paid to how the process is
                carried out. One of such ways to avoid this is cleaning
                inside-out. More than this is the manner the cleaning solution
                is applied and sprayed. If one end is done horizontally, the
                other is better done vertically. Why? This helps in identifying
                streaks in case there is any. There are more professionals of
                Knights Home Service can do. We are creative in what we do like
                no one else in Orange County.
                <br />
                <br />
                Why not hand over the task of window cleaning to the best in
                Orange County? Knights Home Service offer high-quality window
                cleaning services and pressure washing services that are both
                effective and affordable, designed to meet your needs. Their
                work and dedication guarantee a reliable service, a claim
                supported by numerous reviews from satisfied customers.
                <br />
              </div>
              <div className="County__content__left__info__content__info">
                Call Knights Home Service today in Orange County on 03131231 to
                schedule your appointment or get your free estimate. Their team
                of experienced window cleaners is ready to help. Trust us, your
                clean windows will make all the difference!
              </div>
              <button
                title="Get A Free Quote Today"
                onClick={() => {
                  window.location.href = "/contactus";
                }}
                className="Homesection__content__overlay__button button__margin"
              >
                Get A Free Quote Today
              </button>
            </div>
          </div>
          <div className="County__content__right">
            <div className="County__content__right__img">
              <img src={JpegAfter1} alt="img" />
              <img src={JpegBefore2} alt="img" />
              <img src={JpegAfter2} alt="img" />
            </div>
          </div>
        </div>
      </section>
      <footer className="Footer">
        <div className="footerbackground">
          <img loading="lazy" src={PngFooterback} alt="" />
        </div>
        <div className="footer__overlay">
          <div className="Footer__content">
            <div className="Footer__content__left">
              <div
                className="Footer__content__left__logo"
                title="Knights Home Service"
              >
                <img src={PngLogo} alt="img" />
              </div>
              <div className="Footer__content__left__logo__info">
                Our company offers professional home appliance repair services
                and top-notch cleaning services. Our goal is to provide our
                customers with excellent service and satisfaction, which is why
                we offer affordable prices and flexible scheduling options.
              </div>
            </div>
            <div className="Footer__content__mid">
              <div className="Footer__content__mid__content">
                <div className="Footer__content__mid__content__left">
                  <div className="Footer__content__mid__content__left__heading">
                    Quick Links
                  </div>
                  <div className="Footer__content__mid__content__left__links">
                    <Link to="#" onClick={scrollToTop}>
                      Home
                    </Link>
                    <Link to="#" onClick={scrollToTop}>
                      About Us
                    </Link>

                    <Link to="#" onClick={scrollToTop}>
                      Contact Us
                    </Link>
                  </div>
                </div>
                <div className="Footer__content__mid__content__left">
                  <div className="Footer__content__mid__content__left__heading">
                    Company
                  </div>
                  <div className="Footer__content__mid__content__left__links">
                    <Link onClick={scrollToTop} to="#">
                      Privacy Statement
                    </Link>
                    <NavLink onClick={scrollToTop} to="#">
                      Terms of Use
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>
            <div className="Footer__content__right">
              <div className="Footer__content__mid__content__left__heading">
                Stay Updated with us
              </div>
              <div className="Footer__content__right__input__name">
                Your Email
              </div>
              <div className="Footer__content__right__input__button">
                <input
                  className="Footer__content__right__input__button__email"
                  placeholder="Enter your Email"
                  type="email"
                  name="email"
                  id="email"
                />
                <button title="Subscribe">Submit</button>
              </div>
              <div className="Footer__content__right__all__links">
                <a target="_blank" href="https://www.facebook.com/">
                  <Facebook className="Footer__content__right__all__links__link" />
                </a>
                <a target="_blank" href="https://www.instagram.com/">
                  {" "}
                  <Instagram className="Footer__content__right__all__links__link" />
                </a>
                <a target="_blank" href="https://twitter.com/">
                  <Twitter className="Footer__content__right__all__links__link" />
                </a>

                <a target="_blank" href="https://pk.linkedin.com/">
                  {" "}
                  <Linkedin className="Footer__content__right__all__links__link" />
                </a>
              </div>
            </div>
          </div>
          <div className="Footer__bottom">
            <span className="line"> </span>
            <div className="Footer__bottom__heading">
              Copyright © 2024 by Knights Home Service Home appliance repair
              service
            </div>
          </div>
        </div>
      </footer>
      <div
        className="whatsapp__button"
        style={{
          position: "fixed",
          left: "5px",
          bottom: "10px",
          zIndex: "9999",
          cursor: "pointer",
        }}
      >
        <Link to="https://wa.me/" target="_blank">
          <svg
            width="60"
            height="60"
            viewBox="0 0 292 292"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M243.5 0.0332031H48.19C21.5754 0.0332031 0 21.6086 0 48.2232V243.533C0 270.148 21.5754 291.723 48.19 291.723H243.5C270.115 291.723 291.69 270.148 291.69 243.533V48.2232C291.69 21.6086 270.115 0.0332031 243.5 0.0332031Z"
              fill="url(#paint0_linear_261_3592)"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M245.28 143.314C245.28 196.814 201.57 240.194 147.65 240.194C131.152 240.223 114.915 236.077 100.45 228.144L46.4 245.314L64.02 193.314C54.8401 178.253 49.9955 160.951 50.02 143.314C50.02 89.8036 93.73 46.4336 147.66 46.4336C201.59 46.4336 245.29 89.8036 245.29 143.314H245.28ZM147.65 61.8736C102.38 61.8736 65.56 98.4036 65.56 143.324C65.5459 160.504 71.0261 177.239 81.2 191.084L70.94 221.324L102.48 211.324C115.894 220.138 131.6 224.821 147.65 224.794C192.91 224.794 229.74 188.254 229.74 143.344C229.74 98.4336 192.91 61.8736 147.65 61.8736ZM196.95 165.644C196.35 164.644 194.75 164.054 192.37 162.864C189.99 161.674 178.2 155.934 176.01 155.144C173.82 154.354 172.21 153.954 170.63 156.324C169.05 158.694 164.44 164.054 163.04 165.644C161.64 167.234 160.26 167.424 157.86 166.234C155.46 165.044 147.75 162.534 138.61 154.454C133.387 149.654 128.899 144.111 125.29 138.004C123.9 135.634 125.16 134.344 126.34 133.164C127.52 131.984 128.74 130.394 129.93 129.004C130.919 127.793 131.727 126.446 132.33 125.004C132.649 124.351 132.798 123.627 132.761 122.901C132.724 122.176 132.504 121.471 132.12 120.854C131.53 119.664 126.74 107.984 124.74 103.224C122.74 98.4636 120.74 98.6536 119.36 98.6536C118.02 98.7135 116.684 98.8504 115.36 99.0636C115.36 99.0636 110.57 99.6636 108.36 102.064C106.15 104.464 99.98 110.184 99.98 121.864C99.98 133.544 108.55 144.864 109.75 146.424C110.95 147.984 126.3 172.774 150.63 182.284C174.96 191.794 174.97 188.614 179.36 188.214C183.75 187.814 193.51 182.474 195.51 176.924C197.51 171.374 197.51 166.624 196.91 165.644H196.95Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_261_3592"
                x1="145.84"
                y1="0.0332031"
                x2="145.84"
                y2="291.723"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#4AC14B" />
                <stop offset="1" stop-color="#06853A" />
              </linearGradient>
            </defs>
          </svg>
        </Link>
      </div>
      <div
        className="phone__button"
        style={{
          position: "fixed",
          right: "5px",
          bottom: "10px",
          zIndex: "9999",
          cursor: "pointer",
        }}
      >
        <Link to="tel:+">
          <svg
            width="60"
            height="60"
            viewBox="0 0 292 292"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M243.762 0.0332031H48.4517C21.8371 0.0332031 0.261719 21.6086 0.261719 48.2232V243.533C0.261719 270.148 21.8371 291.723 48.4517 291.723H243.762C270.376 291.723 291.952 270.148 291.952 243.533V48.2232C291.952 21.6086 270.376 0.0332031 243.762 0.0332031Z"
              fill="url(#paint0_linear_261_3591)"
            />
            <path
              d="M87.9406 173.78C86.6119 172.618 85.0672 171.729 83.3949 171.164C81.7226 170.599 79.9554 170.368 78.1941 170.486C76.4329 170.604 74.7121 171.068 73.1301 171.851C71.548 172.634 70.1357 173.721 68.9738 175.05L45.383 202.028C44.2211 203.357 43.3323 204.901 42.7673 206.573C42.2023 208.245 41.9723 210.012 42.0902 211.773C42.2082 213.534 42.6719 215.255 43.4549 216.836C44.2378 218.418 45.3247 219.83 46.6534 220.992L62.9497 235.253C71.7946 242.001 79.7515 241.058 79.8847 241.058C83.2553 240.433 89.9828 241.656 94.9106 240.099C114.093 234.017 141.696 221.75 173.131 185.8C204.566 149.851 214.828 118.767 219.78 97.2461C221.32 90.5493 219.616 82.8178 220.046 78.7471C220.046 78.614 220.319 70.7322 213.489 64.7457C213.069 64.3869 212.68 63.9939 212.325 63.5709L201.028 53.4762L196.346 49.7539C193.662 47.4084 190.156 46.225 186.599 46.4638C183.042 46.7027 179.726 48.3443 177.379 51.0277L153.789 78.0061C152.624 79.3353 151.733 80.8811 151.166 82.555C150.6 84.229 150.369 85.9982 150.487 87.7615C150.605 89.5248 151.069 91.2475 151.854 92.831C152.638 94.4146 153.728 95.8279 155.059 96.99L175.385 114.748C167.599 130.167 159.194 144.441 144.752 160.956C132.158 175.364 121.53 183.97 109.445 192.572L87.9406 173.78Z"
              fill="white"
            />
            <path
              d="M60.3987 233.017L62.9532 235.254C71.798 242.002 79.7549 241.059 79.8881 241.059C83.2587 240.434 89.9862 241.657 94.9141 240.1C114.096 234.018 141.699 221.751 173.134 185.801C204.569 149.852 214.828 118.768 219.78 97.2472C221.32 90.5504 219.616 82.8188 220.046 78.7482C220.05 77.472 219.897 76.2001 219.592 74.9609C210.515 164.079 129.542 213.784 60.3987 233.017Z"
              fill="white"
            />
            <path
              d="M182.15 53.5957L168.131 69.6154C174.514 63.185 190.752 51.2496 211.229 69.1817L192.631 52.9025C191.146 51.6107 189.211 50.9586 187.247 51.0885C185.284 51.2184 183.451 52.1197 182.15 53.5957Z"
              fill="white"
            />
            <path
              d="M73.9938 178.852L59.9616 194.872C66.3442 188.441 82.5825 176.506 103.059 194.441L84.4642 178.159C82.9806 176.869 81.0475 176.218 79.0862 176.348C77.1249 176.478 75.2944 177.378 73.9938 178.852Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_261_3591"
                x1="146.102"
                y1="0.0332031"
                x2="146.102"
                y2="291.723"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#4AC14B" />
                <stop offset="1" stop-color="#06853A" />
              </linearGradient>
            </defs>
          </svg>
        </Link>
      </div>
    </>
  );
}
